import { render } from "./UErrorItem.vue?vue&type=template&id=b2659d34"
const script = {}
script.render = render

export default script